import * as React from 'react';

export const EmptySpocList = () => {
    return (
        <>
            <div className="flex h-[76vh] items-start flex-col   py-6  justify-center items-center" style={{ height: '76vh', width: '100%' }}>

                <button className=" h-[72vh] flex flex-grow flex-shrink-0 self-stretch  border-2 border-[#A4B0C0] mx-8 mt-4 mb-12 p-8 rounded-xl flex items-center justify-center" style={{ height: '72vh' }}>
                    <div className="flex justify-center items-center space-x-2 flex flex-col gap-2">
                        <img src="assets/NoDoctor.svg" alt="" height={50} width={50} className="mr-2" />
                        <div className='text-2xl font-semibold block '>No SPOCs found</div>
                        <p className="font-normal text-2xl text-[#70829B]" style={{ color: '#70829B' }}>Click on the “Add New SPOC” <br /> button in the top right corner</p>
                    </div>
                </button>
            </div>

        </>

    );
}